import React from "react";
import { toast, ToastOptions, Id } from "react-toastify/unstyled";

const baseOptions: ToastOptions = {
    position: "bottom-right",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    className: "toast-message",
};

/**
 * Centralized toast wrapper. All call-sites should import `notify` from here
 * rather than reaching into `react-toastify` directly so that styling and
 * behaviour stay consistent. The `.toast-message` class is wired in
 * `src/index.css`.
 */
export const notify = {
    success(message: React.ReactNode, options?: ToastOptions): Id {
        return toast.success(message, { ...baseOptions, ...options });
    },
    error(message: React.ReactNode, options?: ToastOptions): Id {
        return toast.error(message, { ...baseOptions, ...options });
    },
    warning(message: React.ReactNode, options?: ToastOptions): Id {
        return toast.warning(message, { ...baseOptions, ...options });
    },
    info(message: React.ReactNode, options?: ToastOptions): Id {
        return toast.info(message, { ...baseOptions, ...options });
    },
    /**
     * Shows a pending toast that resolves into success/error based on the
     * passed promise. Useful for long-running confirm-style actions.
     */
    promise<T>(
        promise: Promise<T>,
        messages: { pending: string; success: string; error: string },
        options?: ToastOptions,
    ): Promise<T> {
        return toast.promise(promise, messages, { ...baseOptions, ...options }) as Promise<T>;
    },
    dismiss(id?: Id) {
        toast.dismiss(id);
    },
};
